const Rebook = (state) => state.Rebook

export default {
  Rebook
}
